import { render, staticRenderFns } from "./RegionsFarmersGroupsView.vue?vue&type=template&id=150159f0&scoped=true&"
import script from "./RegionsFarmersGroupsView.vue?vue&type=script&lang=js&"
export * from "./RegionsFarmersGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150159f0",
  null
  
)

export default component.exports